import React from 'react';
import { View, ScrollView } from 'react-native';
import MediaCover from 'design-system/src/Widget/MediaCover/MediaCover';
import PayWallHeaderTitle from 'design-system/src/Widget/PayWall/PayWallHeader/PayWallHeaderTitle/PayWallHeaderTitle';
import Metrics from 'design-system/src/Theme/Metrics';
import styled from 'styled-components';
import { IPaywallOrientation } from '../PaywallSection.type';

interface PaywallHomePageLayoutProps {
  mediaCover?: any;
  title?: string;
  subtitle?: string;
  renderBlocks?: React.ReactNode[];
  orientation: IPaywallOrientation;
  isMobile: boolean;
  isLandscape: boolean;
}

const BlockContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 60px;

  @media (max-width: 768px) {
    padding: 0;
  }

  & > * {
    width: 100%;
  }

  & > *:nth-child(2),
  & > *:nth-child(3) {
    width: 50%;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const PaywallHomePageLayout: React.FC<PaywallHomePageLayoutProps> = ({
  mediaCover,
  title,
  subtitle,
  renderBlocks,
  orientation,
  isMobile,
  isLandscape,
}) => (
  <View style={{ minHeight: '100vh' }}>
    <MediaCover
      orientation={orientation}
      isActive={true}
      cover={mediaCover}
      bottomGradientLocation={isMobile ? [0, 0.47, 0.85] : [0, 0.47, 1]}
      bottomGradientStyles={{
        bottom: Metrics.verticalScale(0),
        height: '100%',
      }}
      contentContainerStyle={{ paddingTop: Metrics.verticalScale(0) }}
    >
      <ScrollView
        testID="paywall-home-page-scroll-view"
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          paddingTop: isLandscape ? (isMobile ? 45 : 107) : 178,
          paddingBottom: isMobile ? 16 : 0,
        }}
        style={{
          overflow: isMobile ? 'hidden' : undefined,
        }}
      >
        <View
          style={{
            width: isMobile ? '100%' : '50%',
            marginTop: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <PayWallHeaderTitle
            title={title}
            description={subtitle}
            style={{ marginBottom: isMobile ? 0 : 16 }}
          />
        </View>
        {/* Page blocks */}
        <BlockContainer>{renderBlocks}</BlockContainer>
      </ScrollView>
    </MediaCover>
  </View>
);

export default PaywallHomePageLayout;
